<template>
  <div class="container page" style="width: 100%;height: 100%;background-color: rgb(244, 44, 124)">
    <van-nav-bar :title="$t('auth.top33')" style="color: #fff;" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
	<div style="width: 100%;padding-top: 44px;background-color: #fff;height: 100%">
		<div style="position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;margin-bottom: 4px;" v-for="(v,key) in list" :key="key">
			<div style="width: 80%;
    flex: auto;
    display: flex;
    flex-direction: column;
    text-align: left;
    color: #a9a7b4;
    font-size: 14px;">
				
					<div style="width: 100%;;display: block;;font-weight: 600;padding: 5px 0;margin: 0;color: rgb(41, 41, 41);">
						<span v-if="v.type==1">{{ $t('auth.top34') }}</span>
						<span v-if="v.type==2">{{ $t('auth.top35') }}</span>
						<span v-if="v.type==3">{{ $t('auth.top36') }}</span>
						<span v-if="v.type==4">{{ $t('auth.top37') }}</span>
						<span v-if="v.type==5">{{ $t('auth.top38') }}</span>
						<span v-if="v.type==6">{{ $t('auth.top39') }}</span>
						<span v-if="v.type==7">{{ $t('auth.top40') }}</span>
						<span v-if="v.type==8">{{ $t('auth.top41') }}</span>
						<span v-if="v.type==9">{{ $t('auth.top42') }}</span>
					</div>
					<div style="font-size: 11px;width: 100%;display: block;">
						{{v.addtime}}
					</div>
			</div>
			<div style="color: #f26060;
    font-size: 14px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font-weight: 600;
    flex: auto;
    position: relative;
    overflow: hidden;
    text-align: right;
    vertical-align: middle;
    word-wrap: break-word;">
				<span v-if="v.status==2" style="color: rgb(242, 96, 96);">-{{v.num}}</span>
				<span v-if="v.status==1" style="color: rgb(60, 209, 151);">+{{v.num}}</span>
			</div>
		</div>
	</div>
	
</div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      sum: '',
      double: '',fireworks:"",lang:this.$t("auth.lang"),
      size:""
      
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
      }, 500);
    },
    getUserGameList(){
      this.$http({
        method: 'get',
        url: 'user_get_money_list'
      }).then(res=>{
        if(res.code === 200){
          this.list = res.data;
         
         console.log(this.size, this.double,998);
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }const lang = this.$t("auth.lang");
    if (lang == 'zh') {
      this.rose = '玫瑰';
      this.lily = '百合';
      this.balloon = '氣球'
      this.fireworks='煙花'
    } else if (lang == 'en') {
      this.rose = 'Rose';
      this.lily = 'Lily';
      this.balloon = 'Balloon'
      this.fireworks='Fireworks'
    } else if (lang == 'ja') {
      this.rose = 'バラは';
      this.lily = "リリー·リリー";
      this.balloon = '气球'
      this.fireworks='花火大会'
    } else {
      this.rose = '장미';
      this.lily = '백합';
      this.balloon = '풍선'
      this.fireworks='불꽃놀이'
    }
  },
  
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}
.container .main{
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}
.item_list .time span{
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 25px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}.nav-bar{background: unset;color:#000}::v-deep  .van-nav-bar__title{color:#000}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 35px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}::v-deep .van-nav-bar__title {
  color: #fff;
}
</style>
